import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  title: {
    id: 'product_jp_reassurance_about_us_title',
    defaultMessage: 'Story of Back Market',
  },
  description: {
    id: 'product_jp_reassurance_about_us_description',
    defaultMessage:
      'Back Market is an online store from France, specializing in refurbished products. Now available in 17 countries, including the U.S. and Japan, you can buy quality refurbished items from trusted sellers at great prices. These products have up to 90% less environmental impact than new ones. Choose eco-friendly and budget-friendly options with Back Market.',
  },
  more: {
    id: 'product_jp_reassurance_about_us_button',
    defaultMessage: 'Read more',
  },
} as Record<string, I18nDefinition>
